export default "__VITE_ASSET__sCA8r1un__"